module.exports = __webpack_public_path__ + "static/media/PEUGEOT.6fc077fc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/agsm/img/carBrands/PEUGEOT.png
 ** module id = 1660
 ** module chunks = 0
 **/